import { render, staticRenderFns } from "./PropertyNilaveli.vue?vue&type=template&id=ce140c9c&scoped=true&"
import script from "./PropertyNilaveli.vue?vue&type=script&lang=js&"
export * from "./PropertyNilaveli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce140c9c",
  null
  
)

export default component.exports